import Backbone from 'backbone'
import template from './datasets-text-filter.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import rangeSelectMultiple from './range-select-multiple'
import ValueOrEquation from './value-or-equation'
import selects from 'scoreboard/components/selects'
import Dataset from 'scoreboard/datasets/model/dataset'
import beginsEndsWithOperators from 'scoreboard/datasets/filters/begins-ends-with-operators'
import DataType from 'scoreboard/datasets/model/data-type'
const { CLUSTER } = DataType

var DatasetsTextFilter = Backbone.View.extend({

	events: {
		'change [name=operator]': 'changeOperator'
	},

	/** @type {Dataset} */
	model: null,

	/**
	 * Extra controls that may appear for text filters in filter-step1, depending
	 * on the operator (aka filter type)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the Dataset
	 *
	 * @param {Object} options.filter is the filter we're working with
	 *
	 * @param {Boolean} options.new indicates if this is a new filter
	 *
	 * @param {FilterWizard} options.wizard is the wizard
	 *
	 * @param {FormView} options.formView the FormView
	 */
	initialize: function (options) {
		this.options = options || {}
		this.formView = this.options.formView
		// #50191 prevent blowup editing transformations for value imports
		if (this.model instanceof Dataset) {
			this.field = this.model && this.model.getFieldByFieldIdentifier(
				this.getFieldIdentifier())
		}
		// this is for begins with / ends with, which stores its values in
		// filter.updateType1, filter.equations and filter.values
		this.valueOrEquation = new ValueOrEquation({
			el: this.el,
			model: this.model,
			field: this.field,
			formView: this.formView,
			dataType: _.get(this.field, 'dataType'),
			updateType: this.options.filter.updateType1,
			equation: _.first(this.options.filter.equations),
			// filter.value is used for import transformations, and
			// filter.values is used for dataset filters
			value: this.options.filter.value || _.first(this.options.filter.values),
			allowIncomplete: this.options.allowIncomplete
		})
	},

	render: function () {
		this.$('.datasets-text-filter').empty().append(template())

		// make sure we're displaying the correct form controls
		this.changeOperator()

		this.valueOrEquation.render()

		return this
	},

	/**
	 * Returns the field identifier for the current field selected in the UI
	 */
	getFieldIdentifier: function() {
		var fieldIdentifier = this.$('[name=fieldIdentifier]').val()
		// this happens when working with strongly typed inline filters (#52694)
		if (_.isEmpty(fieldIdentifier)) {
			fieldIdentifier = this.$('[name=fieldId]').val()
		}
		return fieldIdentifier
	},

	changeOperator: function() {
		if (this.preventChangeOperator) {
			return
		}
		var operator = this.$('[name=operator]').val()
		var fieldIdentifier = this.getFieldIdentifier()

		// #50190 don't overwrite existing value for the "value" input
		// if this.options.filter.values is undefined
		if (!_.isNil(this.options.filter.values)) {
			// make sure begins/ends with has the text box pre-populated
			this.$('[name=value]').val(_.first(this.options.filter.values))
		}

		// only display the appropriate controls based on the operator

		var noDisplayedControls = true
		this.$('.datasets-text-filter .control')
			.addClass('is-not-displayed')
			.each(function(index, el) {
				if (this.$(el).hasClass(operator)) {
					noDisplayedControls = false
					this.$(el).removeClass('is-not-displayed')
				}
			}.bind(this))

		this.$('.datasets-text-filter').toggleClass('is-not-displayed', noDisplayedControls)

		// start with Add Equation hidden, and we'll re-enable it where it's needed
		this.$('.add-equation').addClass('is-not-displayed')

		// now render any select-multiples we may need
		this.trigger('change-values-operator', 'contains-any', 'contains-all',
			'does-not-contain-any', 'does-not-contain-all')
		this.trigger('change-values-operator', 'is-any', 'is-not-any')

		if (operator == 'in-the-range') {
			var field = this.model.getFieldByFieldIdentifier(fieldIdentifier)
			rangeSelectMultiple(this.$('[name=rangeIds]'), field.ranges,
				this.options.filter?.rangeIds)
		}
		let operatorsWithoutValues = [
			'begins-with',
			'ends-with',
			'does-not-begin-with',
			'does-not-end-with',
			'is-blank',
			'not-blank',
			'in-the-range',
			'not-in-any-range',
			'matches-regular-expression'
		]
		let oldHideValues = _.includes(operatorsWithoutValues, this.oldOperator)
		let hideValues = _.includes(operatorsWithoutValues, operator)

		// toggle the "values" control based on the operator
		this.$('[name=values], .select.control.is-any').toggleClass('is-not-displayed', hideValues)

		this.valueOrEquation.changeUpdateType()

		// #30824 placeholder for matches regular expression
		if (operator === 'matches-regular-expression') {
			let placeholder = i18n.get('admin.import.transform.placeholder.regularExpression')
			this.$('[name=value]').attr('placeholder', placeholder)
		}

		// process.nextTick sucks, but I've been fighting with events for a
		// a while and don't know what's going on
		process.nextTick(() => {
			if (_.get(this.field, 'dataType') === CLUSTER) {
				if (hideValues && !oldHideValues) {
					// don't copy over the cluster index into the "begins/ends with"
					// input
					this.$('[name=value]').val('')
				}
				if (!hideValues && oldHideValues) {
					// don't copy the "begins/ends with" input into the "is any"
					// area.
					selects.val(this.$('[name=values]'), '')
				}
			}
		})

		this.oldOperator = operator
	},

	/**
	 * Returns whether the operator requires text values to be entered
	 */
	isValuesOperator: function(operator) {
		return operator === 'is-any' || operator === 'is-not-any' ||
			operator === 'contains-all' || operator === 'contains-any' ||
			operator === 'does-not-contain-all' || operator === 'does-not-contain-any' ||
			operator === 'character-length-is-any' || operator === 'character-length-is-not-any'
	},

	test: function() {
		var operator = this.$('[name=operator]').val()

		// #26363 only test valuesOrEquations for operators that display it
		if (beginsEndsWithOperators.includes(operator)) {
			let message = this.valueOrEquation.test()
			if (message) {
				return message
			}
		}

		if (this.options.allowIncomplete) {
			return
		}

		if (operator === 'in-the-range' &&
			_.isEmpty(this.$('[name=rangeIds]').val())) {
			return i18n.get('datasets.fields.ranges.required')
		}

		if (this.isValuesOperator(operator) && _.isEmpty(this.$('[name=values]').val())) {
			return i18n.get('datasets.filters.text.required')
		}
	},

	saveState: function() {
		var filter = this.options.filter
		const operator = this.$('[name=operator]').val() || filter.operator
		if (beginsEndsWithOperators.includes(operator)) {
			filter.updateType1 = this.$('.update-type').val()
			let value = this.$('[name=value]').val()
			if (value !== '') { // #53128
				filter.values = [this.$('[name=value]').val()]
			}
			filter.equations = [this.$('.set-equation').val()]
		}
	},

	cleanup: function() {
		this.$('.datasets-text-filter').empty().addClass('is-not-displayed')
		this.stopListening()
		this.valueOrEquation.cleanup()
		// Prevent change operator from continuing after the field value has been changed
		this.preventChangeOperator = true
	},

	remove: function() {
		this.cleanup()
		_.invokeMap([this.valueOrEquation], 'remove')
	}

})

export default DatasetsTextFilter

DatasetsTextFilter.__filename__ = 'datasets/filters/datasets-text-filter.js'
